var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-button",class:_vm.isBackground ? 'common-button-bg' : 'common-button-no-bg',style:({
    width: _vm.buttonStyle.width,
    color: _vm.buttonStyle.textColor,
    height: _vm.buttonStyle.height,
    lineHeight: _vm.buttonStyle.height
  }),on:{"click":_vm.btnClick}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }